import { useState } from 'react';

let idIndex = 0;
const genId = (prefix: string) => `${prefix}-${++idIndex}`;

type Args = {
  prefix?: string;
  id?: string;
};

export function useGuaranteedId({ prefix = 'id', id: explicitId }: Args = { prefix: 'id' }) {
  const [id] = useState(() => explicitId ?? genId(prefix));

  return id;
}
